var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"px-4 clickable",attrs:{"color":"primary lighten-2","outlined":_vm.isActive !== true},on:{"click":_vm.clicked}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-magnify ")]),_vm._v(" "+_vm._s(_vm.label + (_vm.count != null ? ' (' + _vm.count + ')' : ''))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }